export enum CollectionStage {
  draft = "draft",
  pending = "pending",
  live = "live",
  rejected = "rejected",
  preApprovalPending = "preapproval_pending",
  preApprovedLive = "preapproved",
  allPending = "allPending",
  allLive = "allLive",
  unverifiedLive = "pending_live",
  deleted = "deleted"
}
